import { render, staticRenderFns } from "./TheStakewiseLayout.vue?vue&type=template&id=51ac5584"
import script from "./TheStakewiseLayout.vue?vue&type=script&lang=js"
export * from "./TheStakewiseLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports